import { render, staticRenderFns } from "./SITendik.vue?vue&type=template&id=196a3679&"
import script from "./SITendik.vue?vue&type=script&lang=js&"
export * from "./SITendik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports